<template>
  <v-snackbar
    :value="value"
    :absolute="sticky"
    :class="{
      'vs-snackbar': true,
      [`vs-${type}`]: true,
      'vs-sticky': sticky,
    }"
    :color="$options.barColor(type)"
    :timeout="$options.timeoutDuration(keepOpen)"
    data-test="snackbar"
    rounded="pill"
    @input="$listeners.input"
  >
    <slot />

    <template v-if="!keepOpen" #action>
      <v-icon class="vs-snack-close" small @click="$listeners.input(false)"> close </v-icon>
    </template>
  </v-snackbar>
</template>

<script lang="ts">
import { SnackType } from '@/components/vision/SnackBarType'

const snackType = {
  ERROR: SnackType.ERROR,
  INFO: SnackType.INFO,
  WARN: SnackType.WARN,
}

export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    keepOpen: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: snackType.INFO,
      validator: (value) => Object.values(snackType).includes(value),
    },
    sticky: {
      type: Boolean,
      default: false,
    },
  },
  barColor(type) {
    switch (type) {
      case snackType.ERROR:
        return 'color-red--lighter'
      case snackType.WARN:
        return 'color-yellow--light'
      default:
        return 'color-blue--lighter'
    }
  },
  timeoutDuration(keepOpen) {
    return keepOpen ? -1 : 4000
  },
}
</script>

<style>
.vs-snackbar {
  --textColor: var(--color-white);
  z-index: var(--elevation-snackbar);
}

.vs-snackbar .v-snack__content,
.vs-snackbar .vs-snack-close {
  color: var(--textColor);
}

.vs-snackbar .vs-snack-close {
  margin-right: var(--space-smaller);
}

.vs-snackbar.vs-warn {
  --textColor: var(--color-grey--dark);
}

.vs-snackbar.vs-info {
  --textColor: var(--color-blue--dark);
}

.vs-snackbar.vs-error {
  --textColor: var(--color-red--dark);
}

.vs-snackbar .v-snack__wrapper {
  min-width: auto;
  margin-bottom: var(--space-base);
}

.vs-snackbar.vs-sticky {
  position: sticky;
}
</style>
